/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect, useContext } from 'react';
import { useAlert } from 'react-alert';

import errorHandler from '../../../hoc/ErrorHandler';
import { BLOB_INSTANCE as axios, CONFIRM_ALERT } from '../../../constants';
import context from '../../../context/auth-context';
import errorImage from '../../../assets/images/image-error.png'
import preloader from '../../../assets/images/preloader.gif';
import classes from './CompanyLogo.module.css';
import SlidingPane from '../../UI/SlidingPane/SlidingPane';
import ImageCropper from '../../UI/ImageCropper/ImageCropper';

const CompanyLogo = () => {
    const [logo, setLogo] = useState(null);
    const [newLogo, setNewLogo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError]= useState(false);
    const [logoCropperOpen, setLogoCropperOpen] = useState(false);

    const authContext = useContext(context);
    const alert = useAlert();

    useEffect(() => {
        const getLogoURI = async () => {
            const URI = await axios.get(`/companies/${authContext.companyId}/logo`, {headers: {
                'Company-Code': authContext.companyCode
            }});

            if(URI) {
                const urlCreator = window.URL || window.webkitURL;
                setLogo(urlCreator.createObjectURL(URI.data));
                setLoading(false);
            }else {
                setError(true);
                setLoading(false);
            }
        };

        getLogoURI();

        return () => {
            setLogo(null);
            setLoading(true);
            setLogoCropperOpen(false);
            setNewLogo(null);
            if(error) 
                setError(false);
        }
    }, [authContext.companyId]);

    const logoUpdateHandler = async logo => {
        setLoading(true);

        const response = await axios.patch(`/companies/${authContext.companyId}/logo`, {logo: logo.split(',')[1]}, {headers: {
            Authorization: authContext.accessToken,
            'Company-Code': authContext.companyCode
        }, responseType: 'json'});

        if(response) {
            setLoading(false);
            alert.show(response.data.message, {type: 'success'});
            return setNewLogo(logo);
        }else {
            return setLoading(false);
        }
    };

    const logoCropHandler = logo => {
        setLogoCropperOpen(false);
        return CONFIRM_ALERT('Update logo', `Update ${authContext.companyName} logo?`, logoUpdateHandler.bind(this, logo));
    };

    return (
        <Fragment>
            <div className={classes.CompanyLogo}>
                <label className={classes.LogoBtn} onClick={() => setLogoCropperOpen(true)}>
                    <span className="icon fa-camera"></span>
                </label>
                {!loading ? (!error ? <img src={newLogo ?? logo} alt={authContext.companyName} /> : <img src={errorImage} alt="Logo error" />) : <img src={preloader} alt="Preloader" />}
            </div>
            {(logo || newLogo) && (
                <SlidingPane open={logoCropperOpen} title={`${authContext.companyName} logo`} subtitle="Update company logo" onRequestClose={() => setLogoCropperOpen(false)}>
                    <ImageCropper defaultImage={newLogo ?? logo} imageCropHandler={logo => logoCropHandler(logo)} />
                </SlidingPane>
            )}
        </Fragment>
    );

};

export default errorHandler(CompanyLogo, axios);